import { driver, type Config, type PopoverDOM } from 'driver.js';
import 'driver.js/dist/driver.css';
import './tourStyles.css';

export function createTourDriver(
  overrides?: Partial<Config>,
  onDontShowAgain?: () => void
) {
  return driver({
    showProgress: true,
    animate: true,
    overlayColor: 'rgba(0, 0, 0, 0.75)',
    stagePadding: 8,
    stageRadius: 8,
    popoverClass: 'mengage-tour-popover',
    nextBtnText: 'Próximo',
    prevBtnText: 'Anterior',
    doneBtnText: 'Concluir',
    progressText: '{{current}} de {{total}}',
    allowClose: true,
    smoothScroll: true,
    onPopoverRender: (popover: PopoverDOM) => {
      if (!onDontShowAgain) return;

      // Check if checkbox already exists (avoid duplicates)
      if (popover.wrapper.querySelector('.tour-skip-checkbox')) return;

      const checkboxContainer = document.createElement('label');
      checkboxContainer.className = 'tour-skip-checkbox';
      checkboxContainer.innerHTML = `
        <input type="checkbox" class="tour-skip-input" />
        <span>Não mostrar o tour novamente</span>
      `;

      checkboxContainer.querySelector('input')?.addEventListener('change', () => {
        onDontShowAgain();
      });

      popover.footer.appendChild(checkboxContainer);
    },
    ...overrides,
  });
}

function waitForElement(
  selector: string,
  timeoutMs = 3000
): Promise<Element> {
  return new Promise((resolve, reject) => {
    const el = document.querySelector(selector);
    if (el) {
      resolve(el);
      return;
    }

    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector);
      if (found) {
        observer.disconnect();
        clearTimeout(timer);
        resolve(found);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const timer = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Element ${selector} not found within ${timeoutMs}ms`));
    }, timeoutMs);
  });
}
